export enum Location {
  FLYOUT = 'log_in_flyout',
}

export enum Vendor {
  GOOGLE = 'google',
}
